@if ((loadingService.loading$ | async)) {
  <app-loading @fadeInOut></app-loading>
}
<router-outlet></router-outlet>
